import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Indicador de carga estándar del sitio — minimalista, mismo azul de marca
 * ($main-color: #0066ff en styles.scss). Standalone para poder importarse
 * directo donde se necesite sin depender de un módulo compartido.
 */
@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tg-loading" [class.tg-loading--inline]="inline">
      <span class="tg-loading__spinner" [class.tg-loading__spinner--light]="light" [style.width.px]="size" [style.height.px]="size"></span>
      <span class="tg-loading__label" [class.tg-loading__label--light]="light" *ngIf="label">{{ label }}</span>
    </div>
  `,
  styles: [`
    .tg-loading {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      padding: 40px 0;
    }
    .tg-loading--inline {
      flex-direction: row;
      padding: 0;
      gap: 8px;
    }
    .tg-loading__spinner {
      display: inline-block;
      border: 3px solid rgba(0, 102, 255, 0.15);
      border-top-color: #0066ff;
      border-radius: 50%;
      animation: tg-loading-spin 0.7s linear infinite;
    }
    // Variante para usarse sobre fondos de color (ej. dentro de un botón azul relleno),
    // donde el spinner azul normal queda invisible por falta de contraste.
    .tg-loading__spinner--light {
      border-color: rgba(255, 255, 255, 0.35);
      border-top-color: #fff;
    }
    .tg-loading__label {
      font-size: 13px;
      color: #6b7280;
      font-weight: 500;
    }
    .tg-loading__label--light {
      color: #fff;
    }
    @keyframes tg-loading-spin {
      to { transform: rotate(360deg); }
    }
  `]
})
export class LoadingSpinnerComponent {
  @Input() label = '';
  @Input() size = 32;
  @Input() inline = false;
  @Input() light = false;
}
